import { render, staticRenderFns } from "./MediaAndText.vue?vue&type=template&id=11413b01&scoped=true"
import script from "./MediaAndText.vue?vue&type=script&lang=js"
export * from "./MediaAndText.vue?vue&type=script&lang=js"
import style0 from "./MediaAndText.vue?vue&type=style&index=0&id=11413b01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11413b01",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MediaAndText.vue
// module id = 191
// module chunks = 0